import React from 'react';
import { WalletTable } from '../components/WalletTable';
import { TOP_100_WALLETS } from '../data/wallets';
import { Database, TrendingUp, AlertCircle } from 'lucide-react';
export function Top100Page() {
  return <div className="min-h-screen bg-gray-950" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-266">
        {/* Header */}
        <div className="mb-8" data-id="element-267">
          <h1 className="text-4xl font-bold text-white mb-4" data-id="element-268">
            Top 100 Bitcoin Wallets
          </h1>
          <p className="text-gray-400 text-lg" data-id="element-269">
            Real-time tracking of the largest Bitcoin addresses on the
            blockchain. All data is publicly available and verified through
            multiple sources.
          </p>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-270">
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-271">
            <div className="flex items-start gap-4" data-id="element-272">
              <div className="w-10 h-10 bg-blue-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-273">
                <Database className="w-5 h-5 text-blue-500" data-id="element-274" />
              </div>
              <div data-id="element-275">
                <h3 className="text-white font-bold mb-1" data-id="element-276">Public Data</h3>
                <p className="text-gray-400 text-sm" data-id="element-277">
                  All wallet addresses are publicly visible on the Bitcoin
                  blockchain
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-278">
            <div className="flex items-start gap-4" data-id="element-279">
              <div className="w-10 h-10 bg-purple-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-280">
                <TrendingUp className="w-5 h-5 text-purple-500" data-id="element-281" />
              </div>
              <div data-id="element-282">
                <h3 className="text-white font-bold mb-1" data-id="element-283">Live Tracking</h3>
                <p className="text-gray-400 text-sm" data-id="element-284">
                  Data updated regularly from blockchain explorers
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6" data-id="element-285">
            <div className="flex items-start gap-4" data-id="element-286">
              <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-287">
                <AlertCircle className="w-5 h-5 text-orange-500" data-id="element-288" />
              </div>
              <div data-id="element-289">
                <h3 className="text-white font-bold mb-1" data-id="element-290">Verified Sources</h3>
                <p className="text-gray-400 text-sm" data-id="element-291">
                  Every wallet links to multiple blockchain explorers
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <WalletTable wallets={TOP_100_WALLETS} data-id="element-292" />

        {/* Disclaimer */}
        <div className="mt-8 bg-gray-800/30 border border-gray-700 rounded-xl p-6" data-id="element-293">
          <h3 className="text-white font-bold mb-2 flex items-center gap-2" data-id="element-294">
            <AlertCircle className="w-5 h-5 text-orange-500" data-id="element-295" />
            Important Disclaimer
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-296">
            This data is for educational and research purposes only. Wallet
            labels and entity identifications are based on publicly available
            information and may not be 100% accurate. Some wallets may be
            exchange cold storage, lost coins, or belong to unknown entities.
            Always verify information through multiple sources before making any
            decisions.
          </p>
        </div>
      </div>
    </div>;
}